<template>
    <div class="guide-operate-wrapper" v-show="hasShowGuide">
        <div class="top-operate">
            <a class="close-btn" @click="closeGuide"></a>
        </div>
        <div class="guide-tip">
            如需在文本中加入<span class="tip-blue">链接、跳转、高亮标注，</span> 请到<span class="tip-blue">系统设置>答案组件设置</span>
            中进行设置。
        </div>
        <div class="set-color-btn">
            <RoundButton class="setting-btn" :text="setLabel" @btnClick="setColorClick" />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";

export default {
    name: "FirstGuide",
    props: ["hasShow"],
    components: {
        RoundButton
    },
    computed: {
        hasShowGuide() {
            return this.hasShow && this.showGuide;
        }
    },
    data() {
        return {
            setLabel: "去设置",
            deletePosition: "",
            showGuide: true
        };
    },
    methods: {
        setColorClick() {
            this.close();
            this.$router.replace({ path: "/services/widgetSetting" });
        },
        close() {
            this.$store.dispatch("zhiji/hideModal", "QuestionEditModal");
        },
        closeGuide() {
            this.showGuide = false;
        }
    }
};
</script>

<style lang="less" scoped>
.guide-operate-wrapper {
    position: absolute;
    bottom: -60px;
    right: -279px;
    width: 266px;
    height: 135px;
    padding: 24px 20px 16px;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid #d8e4f0;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
    border-radius: 4px;
    margin-left: 16px;
    margin-top: 8px;
    box-sizing: border-box;

    .top-operate {
        .close-btn {
            cursor: pointer;
            position: absolute;
            top: 8px;
            right: 8px;
            width: 12px;
            height: 12px;
            background: url("@{zhijiStaticImagePath}i-close.png") center center no-repeat;
        }
    }

    .guide-tip {
        width: 224px;
        line-height: 23px;

        .tip-blue {
            color: #2ec2ff;
        }
    }

    .set-color-btn {
        text-align: right;

        .setting-btn {
            margin-right: 0;
        }
    }

    &:after {
        position: absolute;
        left: -18px;
        top: 50%;
        margin-top: -14px;
        display: inline-block;
        content: "";
        width: 18px;
        height: 28px;
        background: url("@{zhijiStaticImagePath}class-spr.png") -357px 0;
    }
}
</style>
